import { useFormat } from '@ideavivat/vivat-2';
import usePurchaseRequest from '@/use/usePurchaseRequest';

const {
  classMap, translate,
} = usePurchaseRequest();

export default {
  types: {
    _increment: {
      name: 'ลำดับ',
      width: '3rem',
    },
    // status: {
    //   name: 'สถานะ',
    //   width: '0.7fr',
    //   filter: (val: string, row: { item: { [key: string]: any }; index: number }) => translate(row.item.purchase_order?.status || '-', true),
    //   class: {
    //     cell: 'text-center',
    //     text: (val: string, row: { item: { [key: string]: any }; index: number }) => classMap(row.item.purchase_order?.status || '-', true).concat(' mr-3'),
    //   },
    // },
    lot: {
      name: 'Lot No.',
      width: '8rem',
      filter: (val: any) => val?.code,
    },
    purchase_order_id: {
      name: 'PO No.',
      width: '8rem',
      filter: (val: any, row: any) => row.item.purchase_order?.code,
    },
    supplier: {
      name: 'ชื่อคู่ค้า',
      width: '1fr',
      class: 'mr-3',
      filter: (val: any, row: any) => row.item.purchase_order.supplier?.name || '-',
    },
    created_at: {
      name: 'วันที่สั่งซื้อ',
      width: '8rem',
      // eslint-disable-next-line
      filter: (val: string) => val ? useFormat.date(val).displayShortThaiDate() : '',
    },
    amount: {
      name: 'จำนวน',
      width: '6rem',
      class: {
        cell: 'text-center',
        text: 'text-right',
      },
      filter: (val: string) => parseFloat(val || '0').toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 }),
    },
    price_per_unit: {
      name: 'ราคาต่อหน่วย',
      width: '8rem',
      class: {
        cell: 'text-center',
        text: 'text-right',
      },
      filter: (val: string) => parseFloat(val || '0').toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 }),
    },
    total: {
      name: 'รวมยอด',
      width: '8rem',
      class: {
        cell: 'text-center',
        text: 'text-right mr-3',
      },
      filter: (val: string, row: any) => parseFloat(`${row.item.price_per_unit * row.item.amount}` || '0').toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 }),
    },
    target_date: {
      name: 'วันที่ส่งสินค้า',
      width: '8rem',
      style: 'text-right',
      // eslint-disable-next-line
      filter: (val: string) => val ? useFormat.date(val).displayShortThaiDate() : '',
    },
  },

  sortable: [
    'target_date',
    'price_per_unit',
    'amount',
    'created_at',
    'purchase_order_id',
  ],
};
